export const VALID_WITH_VOUCHER = 'VALID_WITH_VOUCHER';
export const ONE_WAY_COMBINATION = 'ONE_WAY_COMBINATION';
export const VIRTUAL_INTERLINING = 'VIRTUAL_INTERLINING';
export const VIRTUAL_INTERLINING_WITH_SHORT_CONNECTION_TIME =
  'VIRTUAL_INTERLINING_WITH_SHORT_CONNECTION_TIME';
